<div class="not-found-page">
  <div class="div-center">
    <h1>Error 404</h1>
    <h3>Woops. Looks like this page doesn't exist.</h3>
  </div>
</div>
